import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["dialog", "marksContainer"]

    openModal(event) {
        const marks = JSON.parse(event.currentTarget.dataset.marks)
        this.renderMarks(marks)
        this.dialogTarget.showModal()
    }

    renderMarks(marks) {
        const packMarks = marks.filter(m => m.pack_mark)
        const itemMarks = marks.filter(m => m.item_mark)

        let html = ""

        const totalItemMarks = packMarks.reduce((sum, m) => sum + (m.item_marks || []).length, 0) + itemMarks.length

        if (packMarks.length > 0) {
            html += `<div class="kit-stack" style="gap:var(--space-2);margin-bottom:var(--space-3);">`
            packMarks.forEach((mark, index) => {
                const itemMarksCount = (mark.item_marks || []).length
                html += `
                    <details class="kit-menu" style="border:1px solid var(--color-ink-200);border-radius:var(--radius-md);padding:var(--space-2) var(--space-3);">
                        <summary style="display:flex;align-items:center;gap:var(--space-2);cursor:pointer;">
                            <code class="text-mono">${this.escapeHtml(mark.pack_mark)}</code>
                            <span class="status-badge status-badge--neutral"><span class="status-badge__dot"></span>${itemMarksCount}</span>
                        </summary>
                        <table class="kit-table" style="margin-top:var(--space-2);">
                            <tbody>
                                ${(mark.item_marks || []).map((im, i) => `
                                    <tr>
                                        <td class="text-caption" style="width:1%">${i + 1}</td>
                                        <td><code class="text-mono">${this.escapeHtml(im)}</code></td>
                                    </tr>
                                `).join("")}
                            </tbody>
                        </table>
                    </details>
                `
            })
            html += `</div>`
        }

        if (itemMarks.length > 0) {
            html += `
                <table class="kit-table">
                    <thead>
                        <tr>
                            <th style="width:1%">#</th>
                            <th>Марка единицы</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${itemMarks.map((mark, i) => `
                            <tr>
                                <td class="text-caption">${i + 1}</td>
                                <td><code class="text-mono">${this.escapeHtml(mark.item_mark)}</code></td>
                            </tr>
                        `).join("")}
                    </tbody>
                </table>
            `
        }

        html += `
            <div class="kit-cluster" style="justify-content:flex-end;border-top:1px solid var(--color-ink-200);padding-top:var(--space-2);margin-top:var(--space-2);">
                <span class="text-caption">Общее количество марок:</span>
                <span class="status-badge status-badge--info"><span class="status-badge__dot"></span>${totalItemMarks}</span>
            </div>
        `

        this.marksContainerTarget.innerHTML = html
    }

    closeModal() {
        this.dialogTarget.close()
        this.marksContainerTarget.innerHTML = ""
    }

    closeOnBackdrop(event) {
        if (event.target === this.dialogTarget) this.closeModal()
    }

    escapeHtml(str) {
        return String(str)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
    }
}
